import { useWebshopMessages } from '~/features/webshopmessages/hooks/useWebshopMessages';

export function useHasTopBanner() {
  const { shouldShowMessages } = useWebshopMessages();

  return {
    hasTopBanner: shouldShowMessages
  };
}
